export default "__VITE_ASSET__8fe91aaf__"